export const REACT_ENV = (window._env_ ?? process.env)
